module.exports = __webpack_public_path__ + "img/ae30a22a1a24450fbdecf9675567233c-1024.0348afde.jpg";